export const SIDE_MENU_ID = 'side-menu';
